module.exports = __webpack_public_path__ + "static/media/blog-kaspersky.28417822.jpg";